module.exports = __webpack_public_path__ + "static/media/StylingFee.04ca835b.svg";